<template>
  <el-dialog title="Selecionar Pasta" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" @open="open" width="35%">
    <el-form size="small" label-position="top">
      <el-form-item label="Arquivo" v-if="arquivo">
        <el-input v-model="arquivo.descricao" readonly/>
      </el-form-item>

      <el-form-item label="Diretórios">
        <el-select v-model="diretorio.id" placeholder="Diretórios" filterable clearable loading-text="Carregando...">
          <el-option v-for="item in diretorios" :key="item.id" :label="item.nome" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="selecionarDiretorio()" type="primary" round size="small" class="btn-box-shadow">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { mapActions } from "vuex";

import URLS from '../../util/urls.js';


export default {
  props: {
    visibility: Boolean,
    aluguel: Object,
    venda: Object,
    imovel: Object,
    imovelAluguel: Object,
    cliente: Object,
    clienteAluguel: Object,
    arquivo: Object,
  },

  data() {
    return {
      diretorio: {
        id: undefined
      },
      diretorios: []
    };
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions('loginStore', [
      'relogar',
    ]),
    // IMOVVEL ALUGUEL
    ...mapActions("alugueisImoveisStore", ["selecionarDiretorioArquivoImovelAluguel"]),
    // IMOVEL VENDA
    ...mapActions("vendasImoveisStore", ["selecionarDiretorioArquivoImovelVenda"]),
    // VENDA
    ...mapActions("vendasContratosStore", ["selecionarDiretorioArquivoVenda"]),
    // ALUGUEL
        ...mapActions("alugueisContratosStore", ["selecionarDiretorioArquivoAluguel"]),
    // CLIENTE ALUGUEL
        ...mapActions("alugueisClientesStore", ["selecionarDiretorioArquivoClienteAluguel"]), 
    // CLIENTE VENDA
    ...mapActions("vendasClientesStore", ["selecionarDiretorioArquivoCliente"]),

    open() {
      this.reset();
      this.recuperarDiretorios();
    },

    reset() {
      this.diretorio = {
        id: undefined,
      };
    },

    selecionarDiretorio() {
      this.showLoading();

      if (this.aluguel !== undefined && this.aluguel.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idAluguel: this.aluguel.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoAluguel(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.cliente !== undefined && this.cliente.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idCliente: this.cliente.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoCliente(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.clienteAluguel !== undefined && this.clienteAluguel.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idCliente: this.clienteAluguel.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoClienteAluguel(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.imovelAluguel !== undefined && this.imovelAluguel.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idImovel: this.imovelAluguel.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoImovelAluguel(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.venda !== undefined && this.venda.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idVenda: this.venda.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoVenda(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }

      if (this.imovel !== undefined && this.imovel.id != 0) {
        const payload = {
          diretorio: { 
            id: this.diretorio.id,
            idImovel: this.imovel.id
          },
          id: this.arquivo.id
        }
        this.selecionarDiretorioArquivoImovelVenda(payload).then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }

          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }  
    },

    getPayloadRecuperarDiretorios() {
      let payload= {
        idAluguel: 0,
        idImovel: 0,
        idVenda: 0,
      };
      if(this.venda !== undefined && this.venda.id != 0){
        payload.idVenda = this.venda.id;
      } else if (this.imovel !== undefined && this.imovel.id != 0) {
        payload.idImovel = this.imovel.id;
      } else if (this.aluguel !== undefined && this.aluguel.id != 0) {
        payload.idAluguel = this.aluguel.id;
      } else if (this.imovelAluguel !== undefined && this.imovelAluguel.id != 0) {
        payload.idImovel = this.imovelAluguel.id;
      }else if (this.clienteAluguel !== undefined && this.clienteAluguel.id != 0) {
        payload.idCliente = this.clienteAluguel.id;
      }
      else if (this.cliente !== undefined && this.cliente.id != 0) {
        payload.idCliente = this.cliente.id;
      }

      return payload;
    },

    recuperarDiretorios() {
      const payload = this.getPayloadRecuperarDiretorios();
      this.showLoading();

      this.requestRecuperarDiretorios(payload).then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.diretorios = resultado.lista;
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }).finally(() => {
        this.hideLoading();
      });
    },

    requestRecuperarDiretorios(payload) {
      return axios.post(URLS.ARQUIVOS_LISTAR_DIRETORIOS, payload).then(response => {
        switch(response.data.status) {
          case 'SESSAO_EXPIRADA':
            return this.relogar().then(authResponse => {
              if(authResponse.status === 'SUCESSO') {
                return this.requestRecuperarDiretorios(payload);
              }
            });

          default:
            return response.data;
        }    
      }).catch(error => {
        throw error;
      });
    },

    fechar() {
      this.$emit("close");
    }
  },
};
</script>

